import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: unknown) {
    console.error("[ErrorBoundary]", error, info);
  }

  handleReload = () => {
    this.setState({ error: null });
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 99999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#0b0e13",
            color: "#e8e8e8",
            fontFamily: "monospace",
            padding: 24,
          }}
        >
          <div style={{ maxWidth: 640, width: "100%" }}>
            <h2 style={{ color: "#ff6b6b", marginTop: 0 }}>Scene failed to load</h2>
            <p style={{ wordBreak: "break-word", whiteSpace: "pre-wrap", background: "#1a1f27", padding: 12, borderRadius: 8 }}>
              {this.state.error.message}
            </p>
            {this.state.error.stack && (
              <details style={{ background: "#161b22", padding: 12, borderRadius: 8 }}>
                <summary>Stack trace</summary>
                <pre style={{ whiteSpace: "pre-wrap", fontSize: 12, color: "#9aa4b0" }}>{this.state.error.stack}</pre>
              </details>
            )}
            <button
              onClick={this.handleReload}
              style={{
                marginTop: 16,
                padding: "10px 24px",
                fontSize: 14,
                background: "#2f81f7",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
              }}
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
